import { c as _c } from "react/compiler-runtime";
import { formatCurrency, getPlaneImage } from "@/libs/utils";
import { PlaneDiv, DestinationRowDestination, DestinationRowPrice, DestinationWithTermsGrid, StyledDestinationWithTermRow, StyledDestinationWithTermSlide, TitleH1, TitleH2 } from "@/styles/destination-with-term-slide";
import moment from "moment";
import Image from "next/image";
const DestinationWithTermRow = t0 => {
  const $ = _c(40);
  const {
    orientation,
    row
  } = t0;
  const t1 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t2;
  if ($[0] !== orientation || $[1] !== row.destination_color || $[2] !== row.location || $[3] !== t1) {
    t2 = <DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={t1}>{row.location}</DestinationRowDestination>;
    $[0] = orientation;
    $[1] = row.destination_color;
    $[2] = row.location;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = row.destination_color;
  const t4 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t5;
  if ($[5] !== row.term_start) {
    t5 = moment(row.term_start).format("D.M.");
    $[5] = row.term_start;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== orientation || $[8] !== row.destination_color || $[9] !== t4 || $[10] !== t5) {
    t6 = <DestinationRowDestination $orientation={orientation} $color={t3} $shade={t4}>{t5}</DestinationRowDestination>;
    $[7] = orientation;
    $[8] = row.destination_color;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = row.has_shade_destination ? row.shade_color_destination : undefined;
  let t8;
  if ($[12] !== orientation || $[13] !== row.destination_color || $[14] !== row.nights || $[15] !== t7) {
    t8 = <DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={t7}>{row.nights} nocí</DestinationRowDestination>;
    $[12] = orientation;
    $[13] = row.destination_color;
    $[14] = row.nights;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== orientation || $[18] !== row.board_id?.label || $[19] !== row.departure_location_id?.label || $[20] !== row.destination_color || $[21] !== row.has_shade_destination || $[22] !== row.plane_color || $[23] !== row.shade_color_destination || $[24] !== row.show_board) {
    t9 = !row.show_board ? <div style={{
      display: "flex",
      alignItems: "center",
      gap: "0.1rem"
    }}><PlaneDiv><Image src={`/${getPlaneImage(row.plane_color)}`} alt="plane" fill={true} /></PlaneDiv><DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={row.has_shade_destination ? row.shade_color_destination : undefined}>{row.departure_location_id?.label ?? ""}</DestinationRowDestination></div> : <DestinationRowDestination $orientation={orientation} $color={row.destination_color} $shade={row.has_shade_destination ? row.shade_color_destination : undefined}>{row.board_id?.label ?? ""}</DestinationRowDestination>;
    $[17] = orientation;
    $[18] = row.board_id?.label;
    $[19] = row.departure_location_id?.label;
    $[20] = row.destination_color;
    $[21] = row.has_shade_destination;
    $[22] = row.plane_color;
    $[23] = row.shade_color_destination;
    $[24] = row.show_board;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const t10 = row.price_color;
  const t11 = row.has_shade_price ? row.shade_price_color : undefined;
  let t12;
  if ($[26] !== row.price) {
    t12 = formatCurrency(row.price);
    $[26] = row.price;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== orientation || $[29] !== row.price_color || $[30] !== t11 || $[31] !== t12) {
    t13 = <DestinationRowPrice $orientation={orientation} $color={t10} $shade={t11}>od {t12}</DestinationRowPrice>;
    $[28] = orientation;
    $[29] = row.price_color;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== orientation || $[34] !== t13 || $[35] !== t2 || $[36] !== t6 || $[37] !== t8 || $[38] !== t9) {
    t14 = <StyledDestinationWithTermRow $orientation={orientation}>{t2}{t6}{t8}{t9}{t13}</StyledDestinationWithTermRow>;
    $[33] = orientation;
    $[34] = t13;
    $[35] = t2;
    $[36] = t6;
    $[37] = t8;
    $[38] = t9;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};
const DestinationWithTermSlide = t0 => {
  const $ = _c(29);
  const {
    slide
  } = t0;
  const t1 = slide.orientation;
  const t2 = slide.attributes.position?.value ?? "left";
  const t3 = `https://www.alexandria.cz/${slide.attributes.filePath}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <Image fill={true} alt="" src={t3} priority={true} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = slide.attributes.has_shade_title_1 ? slide.attributes.shade_color_title_1 : undefined;
  let t6;
  if ($[2] !== slide.attributes.color_title_1 || $[3] !== slide.attributes.title_1 || $[4] !== slide.orientation || $[5] !== t5) {
    t6 = <TitleH1 $orientation={slide.orientation} $color={slide.attributes.color_title_1} $shade={t5}>{slide.attributes.title_1}</TitleH1>;
    $[2] = slide.attributes.color_title_1;
    $[3] = slide.attributes.title_1;
    $[4] = slide.orientation;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = slide.attributes.has_shade_title_2 ? slide.attributes.shade_color_title_2 : undefined;
  const t8 = slide.attributes.position?.value ?? "left";
  let t9;
  if ($[7] !== slide.attributes.color_title_2 || $[8] !== slide.attributes.title_2 || $[9] !== slide.orientation || $[10] !== t7 || $[11] !== t8) {
    t9 = <TitleH2 $orientation={slide.orientation} $color={slide.attributes.color_title_2} $shade={t7} $position={t8}>{slide.attributes.title_2}</TitleH2>;
    $[7] = slide.attributes.color_title_2;
    $[8] = slide.attributes.title_2;
    $[9] = slide.orientation;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== slide.attributes.rows || $[14] !== slide.orientation) {
    let t11;
    if ($[16] !== slide.orientation) {
      t11 = (row, index) => <DestinationWithTermRow orientation={slide.orientation} key={index} row={row} />;
      $[16] = slide.orientation;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    t10 = slide.attributes.rows.map(t11);
    $[13] = slide.attributes.rows;
    $[14] = slide.orientation;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <DestinationWithTermsGrid>{t10}</DestinationWithTermsGrid>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t6 || $[22] !== t9) {
    t12 = <div>{t6}{t9}{t11}</div>;
    $[20] = t11;
    $[21] = t6;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== slide.orientation || $[25] !== t12 || $[26] !== t2 || $[27] !== t4) {
    t13 = <StyledDestinationWithTermSlide $orientation={t1} $position={t2}>{t4}{t12}</StyledDestinationWithTermSlide>;
    $[24] = slide.orientation;
    $[25] = t12;
    $[26] = t2;
    $[27] = t4;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export default DestinationWithTermSlide;